export * from './sponsor.service';
export * from './student.service';
export * from './jQuery.service';
export * from './enroll.service';
export * from './init.service';
export * from './admin.service';
export * from './receipts.service';
